import { render } from "./facturations_tab.vue?vue&type=template&id=ac13595a"
import script from "./facturations_tab.vue?vue&type=script&lang=js"
export * from "./facturations_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__